export default function () {
    $(window).on('load', function() {

        // applicable only to asset allocation table in account summary page
        const customTable = $(".asset-allocation .custom-table");
        if (customTable.length) {
            customTableHeightAdjustment();
        }

        $(window).resize(function () {
            if (customTable.length) {
                customTableHeightAdjustment();
            }
        });

        function customTableHeightAdjustment() {
            let elt = $(".custom-table-sticky-col");

            if (elt.length) {
                elt.each(function (index, domElement) {
                    let rowHeight = $(domElement).outerHeight(true);
                    $(domElement).closest('tr').height(rowHeight);
                });
            }
        }
    });
}